export default __webpack_public_path__ + "static/blob2-27bfe013c30286ade6bdd45209ca7442.svg";